module.exports = __webpack_public_path__ + "img/past_event_2.fbb1efab.jpg";